import "./Layout.css";
import { Outlet, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";

function Layout() {

  const [user, setUser] = useState(null);
  const [open, setOpen] = useState(false); // 👈 control dropdown

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) return;

    axios.get("/api/auth/me", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => setUser(res.data))
      .catch(err => console.log(err));

  }, []);

  return (
    <div className="layout-page">

      {/* HEADER */}
      <header className="header">

        <div className="logo-section">
          <img src="/logoNetSof.png" alt="Logo" className="logo" />
          <h2 className="title">NetLedger</h2>
        </div>

        <nav className="nav">
          <Link to="/dashboard" className="link">Inicio</Link>
          <Link to="/companies" className="link">Empresas</Link>
          <Link to="/usuarios" className="link">Usuarios</Link>
          <Link to="/productos" className="link">Productos</Link>
        </nav>

        {/* 👇 USER DROPDOWN */}
        <div className="user-section">

          <button
            className="user-btn"
            onClick={() => setOpen(!open)}
          >
            👤 {user ? user.name : "Cargando..."}
          </button>

          {open && (
            <div className="dropdown">

              <Link to="/profile" className="dropdown-item">
                Información usuario
              </Link>

              <Link to="/settings" className="dropdown-item">
                Configuración
              </Link>

              <Link to="/change-password" className="dropdown-item">
                Cambiar contraseña
              </Link>

              <button
                className="dropdown-item logout"
                onClick={() => {
                  localStorage.removeItem("token");
                  window.location.href = "/";
                }}
              >
                Cerrar sesión
              </button>

            </div>
          )}

        </div>

      </header>

      <main className="main">
        <Outlet />
      </main>

      <footer className="footer">
        <span className="footer-brand">SYNTRIXA S.A.S.</span>

        <span className="footer-copyright">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </span>
      </footer>

    </div>
  );
}

export default Layout;